import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import ContactInfo from "../components/Contact/ContactInfo2";

function Contact() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Contact">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Contact"
          Subheader="Contact"
          bgimg={`${rpdata?.gallery?.length > 5 ? rpdata?.gallery?.[15] : rpdata?.stock?.[5]}`}
        />
        <ContactInfo
        image1={rpdata?.gallery?.length > 3 ? rpdata?.gallery?.[23] : rpdata?.stock?.[3]}
        image={rpdata?.gallery?.length > 13 ? rpdata?.gallery?.[13] : rpdata?.stock?.[13]}
        />
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Contact;
